import { Content } from "antd/es/layout/layout";
import { CustomToast } from "../../composants/toast/CustomToast";
import { ColorsContext } from "../../configurations/context/colorContext";
import { useContext } from "react";

export const CustomBody = ({children}) => {
    const {colors} = useContext(ColorsContext);
    return (
        <Content style={{backgroundColor: colors.COLOR_BODY}} className="min-h-[280px] rounded-lg py-6">
            <div className="flex-grow">
                {children}
                <CustomToast />
            </div>
        </Content>
    );
}